import { EditorState } from 'draft-js';
export function getAnchorKey(state: EditorState): string {
  const selectionState = state.getSelection();
  return selectionState.getAnchorKey();
}
